<template>
    <div id="Asset_DashBoard">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template>
                <div class="page-name">
                    <span class="page-title" id="dashboard">Asset Analytics</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dashboard-page">
                        <section class="internal-container border-top-table-fl">
                            <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="control-label" for="state">Report</label>
                                    <v-select v-model="report_type" name="report_type" placeholder="" label="text" class='close-remove' :options="reportTypeArr" @input="onReportChange">
                                    </v-select>
                                </div>

                                <div class="dropdown-divider"></div>

                                <div class="form-group">
                                    <label class="control-label" for="state">Group</label>
                                    <v-select v-model="asset_group" name="asset_group" placeholder="Select Group" label="text"
                                        class='multiselect'
                                        :options="vehicleGroupArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onGroupChange">
                                    </v-select>
                                </div>

                                <div class="form-group">
                                    <label class="control-label" for="state">Unit Number</label>
                                    <v-select v-model="vehicle" name="vehicle"
                                        class='multiselect custom-ci-auto-search'
                                        id="vehicle-select"
                                        label="text" 
                                        :disabled="asset_group == null || asset_group == ''"
                                        :filterable="false" 
                                        :options="vehicleArr"
                                        :multiple="true"
                                        :searchable="true"
                                        @search="onSearchAsset"
                                        @input="onUnitChange"
                                        placeholder="Select Unit">
                                        <template slot="no-options">
                                            Search Unit...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>

                                <div class="dropdown-divider"></div>

                                <div class="form-group">
                                    <label class="control-label" for="state">Unit Type</label>
                                    <v-select v-model="asset_type" name="asset_type" placeholder="Select Unit Type" label="text" 
                                        class='multiselect'
                                        :options="vehicleTypeArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onAssetTypeChange">
                                    </v-select>
                                </div>

                                <div class="form-group">
                                    <label class="control-label" for="state">Year</label>
                                    <v-select v-model="asset_year" name="asset_year" placeholder="Select Year" label="text" 
                                        class='multiselect'
                                        :options="vehicleYearArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onAssetYearChange">
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="state">Make</label>
                                    <v-select v-model="asset_make" name="asset_make" placeholder="" label="text" 
                                        class='multiselect'
                                        :options="assetMakeArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onAssetMakeChange">
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="state">Model</label>
                                    <v-select v-model="asset_model" name="asset_model" placeholder="Select Model" label="text" 
                                        class='multiselect'
                                        :options="vehicleModelArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onAssetModelChange">
                                    </v-select>
                                </div>

                                <div class="form-group">
                                    <label class="control-label" for="state">Manufacturer</label>
                                    <v-select v-model="asset_manufacturer" name="asset_manufacturer" placeholder="Select Manufacturer" label="text"
                                        class='multiselect'
                                        :options="vehicleManufacturerArr"
                                        :close-on-select="true"
                                        :show-labels="true"
                                        :multiple="true"
                                        :searchable="true"
                                        @input="onAssetManufacturerChange">
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="state">GVW Rating</label>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="state">Body Class</label>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" for="state">Managed By</label>
                                </div>
                                
                            </div>
                            <div class="col-sm-9">
                                <div class="row">
                                    <div class="col-sm-4 form-group">
                                        <label class="control-label" for="fromDate" v-if="isDateBetween">Start Date:</label>
                                        <label class="control-label" for="fromDate" v-else>Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="fromDate" name="fromDate" v-model="fromDate" :config="fromdate_options"></date-picker>
                                            <label for="fromDate" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 form-group" v-if="isDateBetween">
                                        <label class="control-label" for="toDate">End Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="toDate" name="toDate" v-model="toDate" :config="todate_options"></date-picker>
                                            <label for="toDate" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 form-group">
                                        <label class="control-label">&nbsp;</label>
                                        <div class="input-group">
                                            <button type="button" class="btn btn-primary form-control" id="apply" v-on:click="apply()">Apply</button>
                                            <button type="button" class="btn btn-tertiary form-control" id="reset" v-on:click="reset()"><i class="fp-refresh"></i>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                <div id="tabs" class="containerTab">
                                    <div class="tabs">
                                        <a v-on:click="chartTabClick()" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Chart</a>
                                        <a v-on:click="listTabClick()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">List</a>
                                    </div>
                                    <div class="content" id="workorder-detail-tabs">
                                        <div v-show="activetab === 1" class="tabcontent">
                                            <asset-chart id="asset-chart" :fromModule="reportFiltersData" :key="componentKey" ref="loadassetchart"/>
                                        </div>
                                        <div v-show="activetab === 2" class="tabcontent">
                                            <asset-list id="asset-list" :fromModule="reportFiltersData" :key="componentKey" ref="loadassetlist"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </section>
                    </div>
                </div>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import AssetChart from '@/components/dashboard/AssetChart.vue';
Vue.component("asset-chart", AssetChart);
import AssetList from '@/components/dashboard/AssetList.vue';
Vue.component("asset-list", AssetList);
import moment from 'moment';

export default {
    name: "DashBoard",
    components: {
        appFooter: () => import('@/components/Footer'),
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: true,
        loading:false,
        reportFiltersData: null,
        report_type: 'Mean/Median/Mode',
        reportTypeArr: [
            "Mean/Median/Mode",
            "Average RO Cost by Model Year",
            "Average RO Cost by Model",
            "Average RO Cost by Vendor",
            "Average RO Cost by Group",
            "Average RO Count by Group",
            "RO Cost by Unit",
            "RO Cost Per Mile by Unit",
            "RO Cost Per Mile by Model Year",
            "RO Cost by System Code",
            "RO Part Cost by Part Type",
            "Utilization Overview",
            "Utilization Detail",
            "Active Units Detail",
            "Subscription Cost by Group"
        ],

        asset_group: [],
        vehicleGroupArr: [],

        vehicle: null,
        vehicleArr: [],

        asset_type: [],
        vehicleTypeArr: [],

        asset_year: [],
        vehicleYearArr: [],

        asset_make: [],
        assetMakeArr: [],

        asset_model: [],
        vehicleModelArr: [],

        asset_manufacturer: [],
        vehicleManufacturerArr: [],

        isDateBetween: true,
        fromDate: moment().subtract(1, 'months').format("MM/DD/YYYY"),
        fromdate_options: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        toDate: moment().format("MM/DD/YYYY"),
        todate_options: {
            format: 'MM/DD/YYYY',
            showClose: true,
        },

        activetab:1,
        componentKey:0,
    }),
    watch:{

    },
    created: function() {

    },
    mounted: function() {
        let self = this;

        let fromDate = '';
        let toDate = '';
        if(self.fromDate != null ){
            fromDate = self.fromDate;
        }
        if(self.toDate != null ){
            toDate = self.toDate;
        }

        self.getPermissions();
        self.loadFieldData(['location','vehicleType','vehicle_group','vehicle_year','vehicle_manufacturer','vehicle_model']);
        self.reportFiltersData = {
            report_type: {value: self.report_type},
            is_date_between: self.isDateBetween,
            from_date: fromDate,
            to_date: toDate,
        };
    },
    methods: {
        onReportChange(evt){
            let self = this;
            self.report_type = evt;
            self.updateDates();
            self.loadReportData();
        },
        onGroupChange(evt){
            let self = this;
            self.vehicle = null;
            self.loadReportData();
        },
        onSearchAsset(search, loading) {
            let self = this;
            if (search.length > 3) {
                loading(true);
                self.searchField(loading, search, 'search vehicle for chart', self.asset_group);
            }
        },
        onUnitChange(evt){
            let self = this;
            self.loadReportData();
        },
        onAssetTypeChange(evt){
            let self = this;
            self.loadReportData();
        },
        onAssetYearChange(evt){
            let self = this;
            self.loadReportData();
        },
        onAssetMakeChange(evt){
            let self = this;
            self.loadReportData();
        },   
        onAssetModelChange(evt){
            let self = this;
            self.loadReportData();
        },
        onAssetManufacturerChange(evt){
            let self = this;
            self.loadReportData();
        }, 
        chartTabClick(){
            let self = this;
            self.activetab = 1;
        },
        listTabClick(){
            let self = this;
            self.activetab = 2;
        },
        updateDates(){
            let self = this;
            if(self.report_type == 'Mean/Median/Mode' || self.report_type == 'Utilization Overview'){
                self.isDateBetween = true;
                self.fromDate = moment().subtract(1, 'months').format("MM/DD/YYYY");
                self.toDate = moment().format("MM/DD/YYYY");
            } else if(self.report_type == 'Utilization Detail' || self.report_type == 'Active Units Detail'){
                self.isDateBetween = false;
                self.fromDate = moment().format("MM/DD/YYYY");
            }
        },
        reset(){
            //reset date filter
            let self = this;
            self.updateDates();
            self.loadReportData();
        },
        apply(){
            let self = this;
            self.loadReportData();
        },
        loadReportData(){
            let self = this;

            let fromDate = '';
            let toDate = '';
            if(self.fromDate != null ){
                fromDate = self.fromDate;
            }
            if(self.toDate != null ){
                toDate = self.toDate;
            }
            
            self.componentKey += 1;
            self.reportFiltersData = { 
                report_type: {value: self.report_type}, 
                asset_group: self.asset_group,
                vehicle: self.vehicle,
                asset_type: self.asset_type,
                asset_year: self.asset_year,
                asset_make: self.asset_make,
                asset_model: self.asset_model,
                asset_manufacturer: self.asset_manufacturer,

                is_date_between: self.isDateBetween,
                from_date: fromDate,
                to_date: toDate,
                
            };
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/AssetDashboard.vue